import { PluralizePLPipe } from 'ngx-polish-number-to-words';

export const pluralize = new PluralizePLPipe().transform;
